import { createContext, useContext } from 'react'

import type { InternalNavSection } from '../lib/pages.ts'

export interface LandingNavigation {
  sections: readonly InternalNavSection[]
  hiddenPages: readonly string[]
  openCustomization: () => void
}

export const LandingNavigationContext = createContext<LandingNavigation | null>(
  null
)

/** The root layout supplies the same accessible sections to the rail and home. */
export function useLandingNavigation(): LandingNavigation {
  const navigation = useContext(LandingNavigationContext)
  if (navigation === null) {
    throw new Error('The landing page needs the internal navigation layout')
  }
  return navigation
}
